<script>
import { mapActions, mapGetters } from "vuex";

import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";
import scheduleEventMixin from "@/mixins/scheduleEventMixin";

export default {
  mixins: [scheduleEventMixin],

  props: {
    searchFlow: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setInitialHour",
      "setDuration",
      "unsetScheduleEvent",
      "requestProfessionalsAvailable"
    ]),

    availableHour(hour) {
      return (
        this.availableHours.includes(hour) && this.insideScheduleEvent(hour)
      );
    },

    selectedHour(hour) {
      if (this.initialHour !== hour) {
        if (this.searchFlow) {
          this.unsetScheduleEvent();
        }

        this.setInitialHour(hour);
        this.$emit("hourSelected");
      } else {
        this.setInitialHour(null);
      }

      if (this.searchFlow) {
        this.requestProfessionalsAvailable();
      }
    },

    insideScheduleEvent(hour) {
      if (this.searchFlow || !this.scheduleEvent) {
        return true;
      }

      const period = this.$options.filters.period(this.scheduleEvent);

      return hour >= period[0] && hour < period[1];
    }
  },

  computed: {
    ...mapGetters("orderScheduler", ["date", "initialHour", "scheduleEvent"]),

    availableHours: function() {
      return orderSchedulerHelper.nextAvailableHours(this.date);
    },

    purchasableHours: function() {
      return orderSchedulerHelper.purchasableHours();
    }
  },

  filters: {
    formatHour(hour) {
      return (hour < 10 ? "0" : "") + `${hour}h`;
    }
  }
};
</script>

<template>
  <div class="initial-hour">
    <div class="available-hours">
      <div
        v-for="hour in purchasableHours"
        class="hour"
        :key="hour"
        @click="availableHour(hour) && selectedHour(hour)"
        :class="{
          'selected': availableHour(hour) && initialHour === hour,
          'disabled': !availableHour(hour)
        }"
      >
        {{ hour | formatHour }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.initial-hour {
  margin: auto 0;
}

.available-hours {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  grid-gap: 12px;
}

.hour {
  padding: 8px 16px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  color: #424242;
  transition: background-color 0.25s ease-in-out;
  user-select: none;
  cursor: pointer;
}

.selected {
  background-color: #603285;
  color: #fff;
}

.disabled {
  opacity: 0.5;
}

@media (min-width: 1024px) {
  .hour:hover {
    background-color: #603285;
    color: #fff;
    opacity: 0.75;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalFilters/HourPicker.vue